import { render, staticRenderFns } from "./YourDetailsPage.vue?vue&type=template&id=3604bf8e&scoped=true&"
import script from "./YourDetailsPage.vue?vue&type=script&lang=js&"
export * from "./YourDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3604bf8e",
  null
  
)

export default component.exports